import { render, staticRenderFns } from "./SingleEvent.vue?vue&type=template&id=d837e80c&scoped=true"
import script from "./SingleEvent.vue?vue&type=script&lang=js"
export * from "./SingleEvent.vue?vue&type=script&lang=js"
import style0 from "./SingleEvent.vue?vue&type=style&index=0&id=d837e80c&prod&lang=scss"
import style1 from "./SingleEvent.vue?vue&type=style&index=1&id=d837e80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d837e80c",
  null
  
)

export default component.exports